import { createStyles, makeStyles } from "@material-ui/core";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import {
  Box,
  Button,
  FormControl,
  Grid,
  Pagination,
  PaginationItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import MaterialTextFieldComponent from "../../components/textField/MaterialTextFieldCmp";
import {
  ApiResultModel,
  ColumnModel,
  PageInfoModel,
} from "../../models/common.model";
import {
  GetUsersResponse,
  PaginationInfo,
  UsersFilter,
} from "../../models/security.model";
import { GetUsers } from "../../services/security.service";

import createCache from "@emotion/cache";
import { createTheme } from "@mui/material/styles";
import { useHistory } from "react-router-dom";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import ChipCmp from "../../components/chip/chipCmp";
import DatePickerComponents from "../../components/datePicker/DatePickerComponents";
import DropdownCmp2 from "../../components/dropdown/DropdownCmp2";
import { convertToLocalDateTime } from "../../utility/dateUtility";
import AddUserModal from "./components/AddUserModal";
import { useDispatch } from "react-redux";
import { getPassword } from "../../redux/permissions/permissonSlice";

const useStyles = makeStyles((theme) =>
  createStyles({
    select: {
      "&.Mui-selected": {
        backgroundColor: "#CEE5D3 !important",
      },
    },
  })
);
const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});
const userTypeOptions = [
  { title: "سیستمی", id: 1, enumData: "true" },
  { title: "غیر سیستمی", id: 2, enumData: "false" },
];

const columns: readonly ColumnModel[] = [
  { id: "firstName", label: "نام کاربر" },
  { id: "mobileNumber", label: "شماره همراه" },
  { id: "isSystemUser", label: "نوع کاربر" },
  { id: "username", label: "نام کاربری" },
  { id: "createDatePersian", label: "زمان فعالسازی" },
  { id: "notificationEnabled", label: "دریافت اطلاعیه" },
];
const activeStateOptions = [
  { title: "فعال", id: 1, enumData: "true" },
  { title: "غیر فعال", id: 2, enumData: "false" },
];
const UsersAccessList = () => {
  const [isShow, setIsShow] = useState(true);
  const [selectedRow, setSelectedRow] = useState(0);
  const [data, setData] = useState<GetUsersResponse[]>([]);
  const [activeStateValue, setActiveStateValue] = useState<any>();
  const [pageInfo, setPageInfo] = React.useState<PageInfoModel>(
    (): PageInfoModel => {
      let pageInfoModel = new PageInfoModel();
      pageInfoModel.pageNumber = -1;
      pageInfoModel.pageSize = 10;
      pageInfoModel.total = 0;

      return pageInfoModel;
    }
  );
  const queryClient = useQueryClient();
  const tableFilter = {} as UsersFilter;
  queryClient.setQueryData<UsersFilter>("userTableFilter", tableFilter!);
  const [currentPaginationInfo, setCurrentPaginationInfo] = useState(
    (): PaginationInfo => {
      let paginationInfo = {} as PaginationInfo;
      paginationInfo.pageNumber = 1;
      paginationInfo.pageSize = 10;
      return paginationInfo;
    }
  );
  const [requestDate, setRequestDate] = useState<Date[] | null | undefined>(
    null
  );
  const [valueRequestDate, setValueRequestDate] = useState<string>();
  const [userTypeValue, setUserTypeValue] = useState<any>();
  const [openAddUserModal, setOpenAddUserModal] = useState(false);
  const [formData, setFormData] = useState<any>();

  const classes = useStyles();
  const history = useHistory<{
    permissionUserId: number;
  }>();

  const dispatch = useDispatch();

  const nextIcon = () => {
    return (
      <img
        style={{ height: "12px", width: "10px" }}
        src="images/Next.png"
        alt=""
      />
    );
  };
  const previusIcon = () => {
    return (
      <img
        style={{ height: "12px", width: "10px" }}
        src="images/Previous.png"
        alt=""
      />
    );
  };

  const changePageNumber = (newPageNumber: number) => {
    setCurrentPaginationInfo({
      pageNumber: newPageNumber,
      pageSize: 10,
    });
  };

  const handleChangePagination = (event: any, value: any) => {
    changePageNumber(value);
    handleSelectRow(undefined);
  };

  const handleSelectRow = (rowIndex: any) => {};

  const { mutate: GetUsersMutate } = useMutation(GetUsers, {
    onSuccess: (data: ApiResultModel<GetUsersResponse[]>) => {
      if (data) {
        setData(data.data);
        let pageInfoModel = new PageInfoModel();
        pageInfoModel.pageNumber = -1;
        pageInfoModel.pageSize = 10;
        pageInfoModel.total = 0;
        setPageInfo(data.pageInfo !== null ? data.pageInfo : pageInfoModel);
      }
    },
    onError: () => {},
  });

  useEffect(() => {
    const tableFilter = queryClient.getQueryData<UsersFilter>(
      "userTableFilter"
    );
    handleFilterSubmition(tableFilter!);
  }, [currentPaginationInfo]);

  useEffect(() => {
    if (history.action === "POP") {
      setSelectedRow(queryClient.getQueryData<number>("SELECTED_ROW")!);
    }
  }, [history.action]);

  const handleFilterSubmition = (value: UsersFilter) => {
    GetUsersMutate({
      paginationInfo: currentPaginationInfo!,
      filter: value,
    });
  };
  const [userType, setUserType] = useState<any>();
  const [notification, setNotification] = useState<any>();
  const handleSelectedUserTypeDrop = (e: any) => {
    setUserTypeValue(e.target.value);
    let obj = userTypeOptions.filter(
      (item) => item.enumData === e.target.value
    );
    setUserType(obj[0].title);
  };
  const handleSelectedActiveStateDrop = (e: any) => {
    setActiveStateValue(e.target.value);
    let m = activeStateOptions.filter(
      (item) => item.enumData === e.target.value
    );
    setNotification(m[0].title);
  };

  function changeValueRequestDate(e: any) {
    setValueRequestDate(e.toString().replace(/,/g, " - "));
    setRequestDate(e);
  }

  const setChildUserTypeValue = (values: any) => {
    const tableFilter = queryClient.getQueryData<UsersFilter>(
      "userTableFilter"
    );
    setUserTypeValue(undefined);
    setUserType(undefined);
    tableFilter!.isSystemUser = undefined;
    queryClient.setQueryData<UsersFilter>("userTableFilter", tableFilter!);
    handleFilterSubmition(tableFilter!);
  };
  const setChildUserStateValue = (values: any) => {
    const tableFilter = queryClient.getQueryData<UsersFilter>(
      "userTableFilter"
    );
    setActiveStateValue(undefined);
    setNotification(undefined);
    tableFilter!.notificationEnabled = undefined;
    queryClient.setQueryData<UsersFilter>("userTableFilter", tableFilter!);
    handleFilterSubmition(tableFilter!);
  };
  const setChildUserDate = (values: any) => {
    const tableFilter = queryClient.getQueryData<UsersFilter>(
      "userTableFilter"
    );
    setValueRequestDate("");
    setRequestDate(undefined);
    tableFilter!.createDateTime = undefined;
    queryClient.setQueryData<UsersFilter>("userTableFilter", tableFilter!);
    handleFilterSubmition(tableFilter!);
  };
  const setChildUserFirstname = (values: any) => {
    setFormData({ ...formData, firstName: "" });
    const tableFilter = queryClient.getQueryData<UsersFilter>(
      "userTableFilter"
    );
    tableFilter!.firstName = "";
    queryClient.setQueryData<UsersFilter>("userTableFilter", tableFilter!);
    handleFilterSubmition(tableFilter!);
  };
  const setChildUserLastname = (values: any) => {
    setFormData({ ...formData, lastName: "" });
    const tableFilter = queryClient.getQueryData<UsersFilter>(
      "userTableFilter"
    );
    tableFilter!.lastName = "";
    queryClient.setQueryData<UsersFilter>("userTableFilter", tableFilter!);
    handleFilterSubmition(tableFilter!);
  };
  const setChildUserMobile = (values: any) => {
    setFormData({ ...formData, mobileNumber: "" });
    const tableFilter = queryClient.getQueryData<UsersFilter>(
      "userTableFilter"
    );
    tableFilter!.mobileNumber = "";
    queryClient.setQueryData<UsersFilter>("userTableFilter", tableFilter!);
    handleFilterSubmition(tableFilter!);
  };
  const setChildUserUsername = (values: any) => {
    setFormData({ ...formData, username: "" });
    const tableFilter = queryClient.getQueryData<UsersFilter>(
      "userTableFilter"
    );
    tableFilter!.username = "";
    queryClient.setQueryData<UsersFilter>("userTableFilter", tableFilter!);
    handleFilterSubmition(tableFilter!);
  };

  function deleteChip(values: any) {
    const tableFilter = queryClient.getQueryData<UsersFilter>(
      "userTableFilter"
    );
    tableFilter!.firstName = "";
    tableFilter!.lastName = "";
    tableFilter!.username = "";
    tableFilter!.mobileNumber = "";
    tableFilter!.createDateTime = undefined;
    tableFilter!.notificationEnabled = undefined;
    tableFilter!.isSystemUser = undefined;
    queryClient.setQueryData<UsersFilter>("userTableFilter", tableFilter!);
    handleFilterSubmition(tableFilter!);
    setActiveStateValue(undefined);
    setNotification(undefined);
    setUserTypeValue(undefined);
    setUserType(undefined);
    setFormData(undefined);
    setRequestDate(undefined);
  }

  const handleChangeForm = (event: any) => {
    setFormData({ ...formData, [event.target.id]: event.target.value });
  };

  const handleFormSubmit = () => {
    let singleDate;
    let rangeDate;
    if (
      requestDate != null &&
      (requestDate[0] !== undefined || requestDate[1] !== undefined)
    ) {
      singleDate = convertToLocalDateTime(Number(requestDate![0]));
      rangeDate = convertToLocalDateTime(Number(requestDate![1]));
    }
    const objUsersFilter = {} as UsersFilter;
    objUsersFilter.firstName = formData?.firstName;
    objUsersFilter.lastName = formData?.lastName;
    objUsersFilter.mobileNumber = formData?.mobileNumber;
    objUsersFilter.username = formData?.username;

    objUsersFilter.isSystemUser =
      userTypeValue !== undefined
        ? userTypeValue === "true"
          ? true
          : false
        : undefined;
    objUsersFilter.notificationEnabled =
      activeStateValue !== undefined
        ? activeStateValue === "true"
          ? true
          : false
        : undefined;
    objUsersFilter.createDateTime =
      requestDate !== null
        ? requestDate?.length! > 1
          ? rangeDate
          : singleDate
        : undefined;
    queryClient.setQueryData<UsersFilter>("userTableFilter", objUsersFilter);
    handleFilterSubmition(objUsersFilter);
  };
  return (
    <div>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Typography
          color={"#28A745"}
          fontWeight={"bold"}
          padding={"0.5rem"}
          borderRadius={"5px"}
          sx={{
            cursor: "pointer",
            width: "fit-content",
            "&: hover": { color: "#fff", background: "#28A745" },
          }}
          onClick={() => setOpenAddUserModal(true)}
        >
          <AddCircleOutlineIcon sx={{ marginLeft: "7px" }} />
          افزودن کاربر
        </Typography>
        <span className="seprator_gray"></span>
        <Tooltip title="فیلتر" arrow>
          <img
            onClick={() => setIsShow(!isShow)}
            style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
            src="images/filter.png"
            alt=""
          />
        </Tooltip>
      </Box>

      {isShow ? (
        <Box sx={{ flexGrow: 1 }}>
          <div className="row">
            <div
              className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
              style={{ marginTop: "1vh" }}
            >
              <MaterialTextFieldComponent
                // className="shadowTextField"
                helperText={""}
                placeHolder={"نام کاربر"}
                label={"نام کاربر"}
                required={false}
                value={formData?.firstName}
                onChange={(e: any) => handleChangeForm(e)}
                name="firstName"
                id="firstName"
              />
            </div>
            <div
              className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
              style={{ marginTop: "1vh" }}
            >
              <MaterialTextFieldComponent
                // className="shadowTextField"
                helperText={""}
                placeHolder={"نام خانوادگی"}
                label={"نام خانوادگی"}
                required={false}
                value={formData?.lastName}
                onChange={(e: any) => handleChangeForm(e)}
                name="lastName"
                id="lastName"
              />
            </div>
            <div
              className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
              style={{ marginTop: "1vh" }}
            >
              <MaterialTextFieldComponent
                // className="shadowTextField"
                helperText={""}
                placeHolder={"شماره همراه"}
                label={"شماره همراه"}
                required={false}
                value={formData?.mobileNumber}
                onChange={(e: any) => handleChangeForm(e)}
                name="mobileNumber"
                id="mobileNumber"
              />
            </div>
            <div
              className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
              style={{ marginTop: "1vh" }}
            >
              <MaterialTextFieldComponent
                // className="shadowTextField"
                helperText={""}
                placeHolder={"نام کاربری"}
                label={"نام کاربری"}
                required={false}
                value={formData?.username}
                onChange={(e: any) => handleChangeForm(e)}
                name="username"
                id="username"
              />
            </div>
            <div
              className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12 dropdownCmp2-container "
              style={{ marginTop: "1vh" }}
            >
              <DropdownCmp2
                style={{
                  paddingRight: "0 !important",
                }}
                onChange={handleSelectedUserTypeDrop}
                value={userTypeValue}
                label={"نوع کاربر"}
                options={userTypeOptions}
                name="userType"
                id="userType"
                darkTheme={true}
                // defaultValue={dafaultDropdownValue}
              />
            </div>
            <div
              className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12 dropdownCmp2-container"
              style={{ marginTop: "1vh" }}
            >
              <DropdownCmp2
                style={{
                  paddingRight: "0 !important",
                }}
                onChange={handleSelectedActiveStateDrop}
                value={activeStateValue}
                label={"دریافت اطلاعیه"}
                options={activeStateOptions}
                name="activeState"
                id="activeState"
                darkTheme={true}
                // defaultValue={dafaultDropdownValue}
              />
            </div>
            <div
              className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
              style={{ marginTop: "1vh" }}
            >
              <FormControl fullWidth className="shadowDatepicker">
                <DatePickerComponents
                  valueArray={requestDate}
                  // value={new Date(valueRequestDateFrom!)}
                  label={" تاریخ درخواست "}
                  // onChange={(newValue: any) => {
                  //   setRequestDateFrom(newValue);
                  // }}
                  onChange={changeValueRequestDate}
                  range={true}
                />
              </FormControl>
            </div>

            <div
              className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12 butFilter"
              style={{ marginTop: "1vh" }}
            >
              <Button
                fullWidth
                variant="contained"
                // type="submit"
                className="btnForm SuccessDefault  "
                onClick={handleFormSubmit}
              >
                اعمال فیلتر
              </Button>
            </div>
          </div>
          {formData?.firstName ||
          formData?.lastName ||
          formData?.mobileNumber ||
          formData?.username ||
          userTypeValue ||
          activeStateValue ||
          requestDate ? (
            <div
              style={{ display: "flex", alignItems: "center" }}
              className="row tableCMP"
            >
              <Button
                onClick={deleteChip}
                style={{
                  justifyContent: "right",
                  minWidth: "25px",
                  marginRight: "-1vh",
                  marginTop: "1vh",
                }}
              >
                <img
                  style={{ height: "24px", width: "24px" }}
                  src="images/RemoveAllFilters.svg"
                  alt=""
                />
              </Button>

              <ChipCmp
                item={formData?.firstName}
                enamValue={formData?.firstName}
                index={formData?.firstName?.length}
                setChildValue={setChildUserFirstname}
              />
              <ChipCmp
                item={formData?.lastName}
                enamValue={formData?.lastName}
                index={formData?.lastName?.length}
                setChildValue={setChildUserLastname}
              />
              <ChipCmp
                item={formData?.mobileNumber}
                enamValue={formData?.mobileNumber}
                index={formData?.mobileNumber?.length}
                setChildValue={setChildUserMobile}
              />
              <ChipCmp
                item={formData?.username}
                enamValue={formData?.username}
                index={formData?.username?.length}
                setChildValue={setChildUserUsername}
              />
              <ChipCmp
                item={userType}
                enamValue={userType}
                setChildValue={setChildUserTypeValue}
              />
              <ChipCmp
                item={notification}
                enamValue={notification}
                setChildValue={setChildUserStateValue}
              />

              <ChipCmp
                item={valueRequestDate}
                enamValue={valueRequestDate}
                setChildValue={setChildUserDate}
              />
            </div>
          ) : (
            ""
          )}
        </Box>
      ) : (
        ""
      )}
      <br />

      <div className="cardTableBorder">
        <TableContainer
          style={{ background: "#fff", maxHeight: "55vh" }}
          className="boxScroll"
        >
          <Table
            stickyHeader
            aria-label="sticky table"
            style={{ borderCollapse: "collapse" }}
          >
            <TableHead className="rowTHead" style={{ paddingBottom: "10px" }}>
              <TableRow
                classes={{ root: classes.select }}
                className={`${classes} borderRight borderLeft`}
                selected={selectedRow === 0}
              >
                <TableCell
                  className="rowTHead colorTitle textFont12 fontWeight WidthRowNumber"
                  align="right"
                  style={{ width: "10vh", minWidth: "10vh" }}
                >
                  #
                </TableCell>
                {columns.map((column) => (
                  <TableCell
                    className="rowTHead colorTitle textFont12 fontWeight noWrap"
                    key={column.id}
                    align="right"
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <div style={{ width: "100%", height: "10px" }}></div>
            <TableBody>
              {data
                ? data.map((row, rowIndex) => {
                    return (
                      <TableRow
                        classes={{ root: classes.select }}
                        className={`${
                          rowIndex % 2 === 0 ? "rowTBodyE  " : "rowTBodyO "
                        } ${classes} borderRight borderLeft cursorPointer noWrap`}
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={row.id}
                        selected={selectedRow === rowIndex}
                        onClick={() => {
                          window.localStorage.setItem(
                            "PermissionUserId",
                            String(row.id)
                          );
                          history.push({
                            pathname: "/userDetail",
                            state: { permissionUserId: row.id },
                          });
                          dispatch(
                            getPassword({
                              password: undefined,
                            })
                          );
                          setSelectedRow(rowIndex);

                          queryClient.setQueryData("SELECTED_ROW", rowIndex);
                        }}
                      >
                        <TableCell
                          className="textFont12 WidthRowNumber"
                          style={{ width: "10vh", minWidth: "10vh" }}
                        >
                          {((currentPaginationInfo.pageNumber ?? 0) - 1) *
                            (currentPaginationInfo.pageSize! ?? 0) +
                            rowIndex +
                            1}
                        </TableCell>

                        {columns.map((column) => {
                          const value =
                            row[column.id as keyof GetUsersResponse];
                          return (
                            <>
                              {column.id === "notificationEnabled" ? (
                                <TableCell
                                  className="textFont12"
                                  key={column.id}
                                  align="right"
                                >
                                  {value ? (
                                    <span style={{ color: "#01AF43" }}>
                                      فعال
                                    </span>
                                  ) : (
                                    <span style={{ color: "#E6123D" }}>
                                      غیر فعال
                                    </span>
                                  )}
                                </TableCell>
                              ) : (
                                <>
                                  {column.id === "firstName" ? (
                                    <TableCell
                                      className="textFont12"
                                      key={column.id}
                                      align="right"
                                    >
                                      {value !== null &&
                                        value + " " + row?.lastName}
                                    </TableCell>
                                  ) : (
                                    <TableCell
                                      className="textFont12"
                                      key={column.id}
                                      align="right"
                                    >
                                      {column.id === "isSystemUser"
                                        ? value
                                          ? "سیستمی"
                                          : "غیر سیستمی"
                                        : column.format && column.hasFormat
                                        ? column.format(value)
                                        : value?.toString()}
                                    </TableCell>
                                  )}
                                </>
                              )}
                            </>
                          );
                        })}
                      </TableRow>
                    );
                  })
                : null}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <div>
        <Grid container spacing={2} alignItems="center">
          <Grid
            item
            xs={12}
            sm={4}
            display="flex"
            justifyContent={{ xs: "center", sm: "flex-start" }}
          >
            <span
              style={{ color: "#1D4A87", top: "1vh", position: "relative" }}
            >
              تعداد کل :
              <span style={{ color: "#01AF43" }}>{pageInfo.total}</span> مورد
            </span>
          </Grid>
          <Grid item xs={12} sm={4} display="flex" justifyContent="center">
            <Pagination
              renderItem={(item) => (
                <PaginationItem
                  components={{
                    previous: previusIcon,
                    next: nextIcon,
                  }}
                  {...item}
                />
              )}
              // color="primary"
              sx={{
                direction: "ltr",
                margin: "5px",
                button: {
                  color: "#25D1C9",
                  fontSize: "14px !important",
                  fontFamily: "iranSans",
                },
              }}
              count={
                pageInfo ? Math.ceil(pageInfo.total / pageInfo.pageSize) : 0
              }
              onChange={handleChangePagination}
              page={currentPaginationInfo.pageNumber}
            />
          </Grid>
          <Grid item xs={12} sm={4}></Grid>
        </Grid>
      </div>
      <AddUserModal
        openAddUserModal={openAddUserModal}
        setOpenAddUserModal={setOpenAddUserModal}
      />
    </div>
  );
};

export default UsersAccessList;
